"use client";

import { useState } from "react";
import { ShoppingCart, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AddToCartButtonProps {
  text: string;
  fontId: string;
  colorId: string;
  widthCm: number;
  heightCm: number;
  depthMm: number;
  fontsReady: boolean;
}

export function AddToCartButton({
  text,
  fontId,
  colorId,
  widthCm,
  heightCm,
  depthMm,
  fontsReady,
}: AddToCartButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch("/api/wix/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, fontId, colorId, widthCm, heightCm, depthMm }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.error ?? "Unbekannter Fehler.");
      }
      const { checkoutUrl } = await response.json();
      window.location.href = checkoutUrl;
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Der Warenkorb konnte nicht erstellt werden."
      );
      setLoading(false);
    }
  }

  return (
    <div className="space-y-2">
      <Button
        type="button"
        size="lg"
        className="w-full bg-blue-600 text-white hover:bg-blue-700 focus-visible:ring-blue-600/50"
        disabled={!fontsReady || !text.trim() || loading}
        onClick={handleClick}
      >
        {loading ? (
          <Loader2 className="size-4 animate-spin" />
        ) : (
          <ShoppingCart className="size-4" />
        )}
        In den Warenkorb
      </Button>
      {error ? (
        <p className="text-sm text-red-400">{error}</p>
      ) : (
        <p className="text-center text-xs text-white/70">
          Führt direkt zur Wix-Kasse für dieses Logo. Bitte den Kauf dort
          abschliessen – bei Abbruch geht die Konfiguration verloren und
          müsste neu erstellt werden.
        </p>
      )}
    </div>
  );
}
